export default function StudentNameGuidance({ id }) {
  return (
    <p id={id} className="text-sm text-muted-foreground leading-relaxed">
      Enter the student's full first and last name. PagePledge automatically shortens
      last names for privacy, showing an initial followed by a period. If students
      in the class share a first name, we use extra letters or a number to tell them apart.
      Even very short last names are never saved or shown in full.
    </p>
  );
}
